import React from "react"
import propTypes from "prop-types"
import "./styles.scss"

import Title from "./components/Title"
import Description from "./components/Description"
import ReadMore from "./components/ReadMore"

const Card = ({ children, className }) => {
  return <div className={["card", className].join(" ")}>{children}</div>
}

Card.propTypes = {
  children: propTypes.oneOfType([propTypes.node, propTypes.string]).isRequired,
  className: propTypes.string
}

Card.defaultProps = {
  className: ""
}

export { Title, Description, ReadMore }

export default Card
